import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ onChange, testid = "signature-pad" }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);
  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#070707";
  }, []);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); if (empty) setEmpty(false); };
  const up = () => { if (!drawing.current) return; drawing.current = false; onChange(empty ? null : ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(null); };
  return (
    <div>
      <div className="relative">
        <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
          className="w-full h-40 rounded-2xl border border-dashed border-[#C8BDAB] bg-white touch-none cursor-crosshair" data-testid={testid} />
        {empty && <p className="absolute inset-0 grid place-items-center text-sm text-[#757575] pointer-events-none">Firma qui con il dito o il mouse</p>}
      </div>
      <button type="button" onClick={clear} className="mt-2 inline-flex items-center gap-1 text-xs text-[#757575] hover:text-black" data-testid={`${testid}-clear`}><Eraser className="h-3.5 w-3.5" /> Cancella firma</button>
    </div>
  );
};
